import React, { Component } from 'react';
import CheckboxSection from "./CheckboxSection";
import ConfiguracionContraseniaDetallada from "./ConfiguracionContraseniaDetallada";

const ConfiguracionContrasenia = (props) => {
    return (
        <div className="">
            <div className="divisor-section">
                <h3>Configuración de contraseña</h3>
            </div>

            {(props.alfabetica || props.numerica || props.caracteresEspeciales || props.caseSensitive) ?
                (<div>
                <h5 className="configuration-view-subtitle">La contraseña debe solicitar...</h5>
            </div>) : null}

            <div className="">
                <CheckboxSection message="Caracteres alfabéticos" isChecked={props.alfabetica}/>
                <CheckboxSection message="Caracteres numéricos" isChecked={props.numerica}/>
                <CheckboxSection message="Caracteres especiales" isChecked={props.caracteresEspeciales}/>
                <CheckboxSection message="Caracteres en mayuscúlas y en minuscúlas" className="box" isChecked={props.caseSensitive}/>
            </div>

            {(props.permitirRepetirPosicion || props.caracteresMinimos != null || props.permiteCaracteresIguales)?
                (<div>
                <h5 className="configuration-view-subtitle">y debe validar que...</h5>
                </div>) : null}

            <div className="">
                <CheckboxSection message="La cantidad mínima de caracteres para la contraseña sea de: "
                    isChecked={props.caracteresMinimos != null}
                    value={props.caracteresMinimos}
                    extencion=" caracteres" />

                <CheckboxSection message="No permita la repetición de un mismo caracter"
                    isChecked={props.permiteCaracteresIguales}/>

                {(props.permiteCaracteresIguales && props.permiteCaracteresIguales == true) ?
                    (<ConfiguracionContraseniaDetallada permiteCaracteresIguales={props.permiteCaracteresIguales}
                        permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                        permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                        permiteRepetirPosicion={props.permiteRepetirPosicion}
                        radioButtonChangeContrasenia={props.radioButtonChangeContrasenia} />) :
                    (null)}
            </div>

            <div className="row col-md-12">
                <CheckboxSection message="No permita el mismo caracter en la misma posición en la contraseña actual y en la próxima contraseña"
                    isChecked={props.permiteRepetirPosicion} />
            </div>

        </div>
    );
};

export default ConfiguracionContrasenia;